export function sortAdicionalesServicio(a, b) {
  if (a.adicional && b.adicional) {
    if (a.adicional.nombre > b.adicional.nombre) {
      return 1;
    } else if (a.adicional.nombre < b.adicional.nombre) {
      return -1;
    }
    return 0;
  } else if (a.adicional && !b.adicional) {
    if (a.adicional.nombre > b.tipoProductoAdicional.adicional.nombre) {
      return 1;
    } else if (a.adicional.nombre < b.tipoProductoAdicional.adicional.nombre) {
      return -1;
    }
    return 0;
  } else if (!a.adicional && b.adicional) {
    if (a.tipoProductoAdicional.adicional.nombre > b.adicional.nombre) {
      return 1;
    } else if (a.tipoProductoAdicional.adicional.nombre < b.adicional.nombre) {
      return -1;
    }
    return 0;
  } else if (!a.adicional && !b.adicional) {
    if (a.tipoProductoAdicional.adicional.nombre > b.tipoProductoAdicional.adicional.nombre) {
      return 1;
    } else if (a.tipoProductoAdicional.adicional.nombre < b.tipoProductoAdicional.adicional.nombre) {
      return -1;
    }
    return 0;
  }
}

export function sortTipoAdicionalesServicio(a, b) {
  if (a.tipoProductoAdicional.adicional.nombre > b.tipoProductoAdicional.adicional.nombre) {
    return -1;
  } else if (a.tipoProductoAdicional.adicional.nombre < b.tipoProductoAdicional.adicional.nombre) {
    return 1;
  }
  return 0;
}

export function renderEspecialistaTabla(empleado) {
  return `${empleado.nombre} ${empleado.apellido}`;
}

export function renderServicio(item) {
  return `${item.nombre}`;
}


// WEBPACK FOOTER //
// ./src/core/util/business.js